import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import UpdateListing from '../../components/Proposal/UpdateListing/UpdateListing'
import { PROPOSAL_TYPE_NAME } from '../../constants/proposalTypes'

UpdateListing.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const proposalType = PROPOSAL_TYPE.UPDATE_ATTRIBUTE

const props = {
  proposalType,
  proposalTypeName: PROPOSAL_TYPE_NAME[proposalType]
}

const UpdateAttributeContainer = WithProposalContainer(UpdateListing, props)

export default UpdateAttributeContainer
